<template>
  <ubi-page-container wide-main-content>
    <ubi-panel class="social-panel">

      <!-- En-tête -->
      <div class="header-section">
        <p class="header-subtitle">Connectez vos comptes professionnels pour automatiser la diffusion de vos annonces et suivre vos performances.</p>
      </div>

      <!-- Vos Dialogues natifs ElementUI (Inchngés) -->
      <el-dialog class="dialogFacebookPages" :visible.sync="dialogFacebookPages">
        <span slot="title">{{ $t("socialNetworks.dialogPagesSelection") }}</span>
        <span>
          <el-form>
            <el-radio-group v-model="choixFacebookPage">
              <div v-for="page in pagesFacebook" :key="page.id">
                <el-row>
                  <el-col :md="24">
                    <el-radio :label="page.id">
                      <span style="padding: 10px;"><img :src="'https://graph.facebook.com/' + page.id + '/picture?type=large'" width="40px" style="text-align: center; vertical-align: middle; border-radius: 6px;"  alt="Avatar Facebook"/></span>
                      <a :href="'https://www.facebook.com/' + page.id" target="_blank">{{ page.name }}</a>
                    </el-radio>
                  </el-col>
                </el-row>
              </div>
            </el-radio-group>
          </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="savePageFacebook"><span>{{ $t("portals.list.confirm") }}</span></el-button>
        </span>
      </el-dialog>

      <el-dialog class="dialogFacebookPages" :visible.sync="dialogLinkedinOrganizations">
        <span slot="title">{{ $t("socialNetworks.dialogOrganizationsSelection") }}</span>
        <span>
          <el-form>
            <el-radio-group v-model="choixLinkedinOrganization">
              <div v-for="organization in linkedinOrganizations" :key="organization.id">
                <el-row>
                  <el-col :md="24">
                    <el-radio :label="organization.id">
                      <span style="padding: 10px;">
                        <img
                          v-if="organization.logoUrl"
                          :src="organization.logoUrl"
                          width="40px"
                          style="text-align: center; vertical-align: middle; border-radius: 6px;"
                          alt=""
                        >
                      </span>
                      <a :href="'https://www.linkedin.com/company/' + organization.id" target="_blank">{{ organization.localizedName }}</a>
                    </el-radio>
                  </el-col>
                </el-row>
              </div>
            </el-radio-group>
          </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveOrganizationLinkedin"><span>{{ $t("portals.list.confirm") }}</span></el-button>
        </span>
      </el-dialog>

      <!-- SDK Facebook initialisé une seule fois (bouton XFBML masqué) -->
      <FacebookLogin
        v-if="possedeFacebook || possedeInstagram"
        ref="facebookLogin"
        hide-button
        :on-success="handleFacebook"
        class="facebook-login-host"
      />

      <!-- GoogleLogin masqué : dialogs + auth ; les CTA design appellent login/logout via ref -->
      <GoogleLogin
        v-if="possedeGmb"
        ref="googleLogin"
        hide-buttons
        class="google-login-host"
        @connection-change="onGoogleConnectionChange"
        @location-change="onGoogleLocationChange"
      />

      <!-- CONTENEUR DES LISTES DYNAMIQUES -->
      <div class="integrations-container" v-loading="loadingStatus">

        <!-- ============================================== -->
        <!-- SECTION 1 : ACTIONS REQUISES (URGENCE)         -->
        <!-- ============================================== -->
        <div v-if="hasWarnings" id="section-warning" class="status-section">
          <div class="section-header">
            <i class="el-icon-warning-outline"></i> {{ $t('socialNetworks.sectionActionsRequired', { count: warningsCount }) }}
          </div>
          <div class="integration-list">

            <!-- Facebook (Erreur) -->
            <div v-if="fbWarning" class="integration-item is-warning">
              <div class="item-icon"><img alt="Facebook" :src="require(`@/assets/facebook-logo-5-1.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>Facebook Pages</h4>
                <a
                  v-if="facebookAccount"
                  :href="'https://www.facebook.com/' + facebookAccount.id"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="account-link"
                >
                  <img
                    :src="'https://graph.facebook.com/' + facebookAccount.id + '/picture?type=large'"
                    alt=""
                    class="account-avatar"
                  >
                  <span class="account-name">{{ facebookAccount.name }}</span>
                  <i class="el-icon-top-right account-external-icon" aria-hidden="true" />
                </a>
                <div class="alert-inline">
                  <i class="el-icon-warning-outline" aria-hidden="true" />
                  <p class="card-message">{{ $t('socialNetworks.messageFacebookAutologin') }}</p>
                </div>
              </div>
              <div class="item-action">
                <button type="button" class="uniform-btn btn-reconnect" @click="reconnectFacebook">
                  {{ $t('socialNetworks.reconnect') }}
                </button>
              </div>
            </div>

            <!-- Instagram (Erreur) -->
            <div v-if="igWarning" class="integration-item is-warning">
              <div class="item-icon"><img alt="Instagram" :src="require(`@/assets/2048px-Instagram_icon.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>Instagram Business</h4>
                <a
                  v-if="instagramAccount && instagramAccount.username"
                  :href="'https://www.instagram.com/' + instagramAccount.username"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="account-link"
                >
                  <img
                    v-if="instagramAccount.profile_picture_url"
                    :src="instagramAccount.profile_picture_url"
                    alt=""
                    class="account-avatar"
                  >
                  <span class="account-name">{{ instagramAccountLabel }}</span>
                  <i class="el-icon-top-right account-external-icon" aria-hidden="true" />
                </a>
                <div class="alert-inline">
                  <i class="el-icon-warning-outline" aria-hidden="true" />
                  <p class="card-message">{{ $t('socialNetworks.messageFacebookAutologin') }}</p>
                </div>
              </div>
              <div class="item-action">
                <button type="button" class="uniform-btn btn-reconnect" @click="reconnectFacebook">
                  {{ $t('socialNetworks.reconnect') }}
                </button>
              </div>
            </div>

            <!-- LinkedIn (Erreur) -->
            <div v-if="inWarning" class="integration-item is-warning">
              <div class="item-icon"><img alt="LinkedIn" :src="require(`@/assets/linkedin-logo.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>LinkedIn</h4>
                <a
                  v-if="linkedinOrganization && linkedinOrganization.id"
                  :href="'https://www.linkedin.com/company/' + linkedinOrganization.id"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="account-link"
                >
                  <img
                    v-if="linkedinOrganization.logoUrl"
                    :src="linkedinOrganization.logoUrl"
                    alt=""
                    class="account-avatar"
                  >
                  <span class="account-name">{{ linkedinOrganization.localizedName }}</span>
                  <i class="el-icon-top-right account-external-icon" aria-hidden="true" />
                </a>
                <div class="alert-inline">
                  <i class="el-icon-warning-outline" aria-hidden="true" />
                  <p class="card-message">{{ $t('socialNetworks.messageFacebookAutologin') }}</p>
                </div>
              </div>
              <div class="item-action">
                <a
                  v-if="connexionLinkedin"
                  :href="connexionLinkedin"
                  target="_blank"
                  class="uniform-btn btn-reconnect"
                >{{ $t('socialNetworks.reconnect') }}</a>
              </div>
            </div>

            <!-- Google (Erreur) -->
            <div v-if="gmbWarning" class="integration-item is-warning">
              <div class="item-icon"><img alt="Google Business" :src="require(`@/assets/1200px-Google-My-Business_logo.svg.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>Google Business Profile</h4>
                <p v-if="gmbManagedByNetwork" class="card-message">{{ $t('socialNetworks.gmbManagedByNetwork') }}</p>
                <a
                  v-if="googleLocation && googleLocation.title && googleLocation.websiteUri"
                  :href="googleLocation.websiteUri"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="account-link"
                >
                  <span class="account-name">{{ googleLocation.title }}</span>
                  <i class="el-icon-top-right account-external-icon" aria-hidden="true" />
                </a>
                <span
                  v-else-if="googleLocation && googleLocation.title"
                  class="account-link account-link--static"
                >
                  <span class="account-name">{{ googleLocation.title }}</span>
                </span>
                <div v-if="!gmbManagedByNetwork" class="alert-inline">
                  <i class="el-icon-warning-outline" aria-hidden="true" />
                  <p class="card-message">{{ $t('socialNetworks.messageFacebookAutologin') }}</p>
                </div>
              </div>
              <div class="item-action">
                <button type="button" class="uniform-btn btn-reconnect" :disabled="gmbManagedByNetwork" @click="reconnectGoogle">
                  {{ $t('socialNetworks.reconnect') }}
                </button>
              </div>
            </div>

          </div>
        </div>

        <!-- ============================================== -->
        <!-- SECTION 2 : CONNEXIONS ACTIVES (SUCCÈS)        -->
        <!-- ============================================== -->
        <div v-if="hasSuccess" id="section-success" class="status-section">
          <div class="section-header">
            <i class="el-icon-circle-check"></i> {{ $t('socialNetworks.sectionActiveConnections', { count: successCount }) }}
          </div>
          <div class="integration-list">

            <!-- Facebook (Succès) -->
            <div v-if="fbSuccess" class="integration-item is-success">
              <div class="item-icon"><img alt="Facebook" :src="require(`@/assets/facebook-logo-5-1.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>Facebook Pages</h4>
                <a
                  v-if="facebookAccount"
                  :href="'https://www.facebook.com/' + facebookAccount.id"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="account-link"
                >
                  <img
                    :src="'https://graph.facebook.com/' + facebookAccount.id + '/picture?type=large'"
                    alt=""
                    class="account-avatar"
                  >
                  <span class="account-name">{{ facebookAccount.name }}</span>
                  <i class="el-icon-top-right account-external-icon" aria-hidden="true" />
                </a>
                <p v-if="disconnectErrors.facebook" class="card-error">{{ disconnectErrors.facebook }}</p>
              </div>
              <div class="item-badge"><div class="status-pill"><i class="el-icon-success"></i> {{ $t('socialNetworks.badgeConnected') }}</div></div>
              <div class="item-action">
                <button
                  v-if="facebookAccount"
                  type="button"
                  class="uniform-btn btn-secondary"
                  @click="confirmDisconnect('Facebook', deconnexionFacebook)"
                >
                  {{ $t('socialNetworks.disconnect') }}
                </button>
              </div>
            </div>

            <!-- Instagram (Succès) — même binding que main -->
            <div v-if="igSuccess" class="integration-item is-success">
              <div class="item-icon"><img alt="Instagram" :src="require(`@/assets/2048px-Instagram_icon.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>Instagram Business</h4>
                <a
                  v-if="instagramAccount && instagramAccount.username"
                  :href="'https://www.instagram.com/' + instagramAccount.username"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="account-link"
                >
                  <img
                    v-if="instagramAccount.profile_picture_url"
                    :src="instagramAccount.profile_picture_url"
                    alt=""
                    class="account-avatar"
                  >
                  <span class="account-name">{{ instagramAccountLabel }}</span>
                  <i class="el-icon-top-right account-external-icon" aria-hidden="true" />
                </a>
                <p v-if="disconnectErrors.facebook" class="card-error">{{ disconnectErrors.facebook }}</p>
              </div>
              <div class="item-badge"><div class="status-pill"><i class="el-icon-success"></i> {{ $t('socialNetworks.badgeConnected') }}</div></div>
              <div class="item-action">
                <button
                  type="button"
                  class="uniform-btn btn-secondary"
                  @click="confirmDisconnect('Instagram', deconnexionFacebook)"
                >
                  {{ $t('socialNetworks.disconnect') }}
                </button>
              </div>
            </div>

            <!-- LinkedIn (Succès) -->
            <div v-if="inSuccess" class="integration-item is-success">
              <div class="item-icon"><img alt="LinkedIn" :src="require(`@/assets/linkedin-logo.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>LinkedIn</h4>
                <a
                  v-if="linkedinOrganization && linkedinOrganization.id"
                  :href="'https://www.linkedin.com/company/' + linkedinOrganization.id"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="account-link"
                >
                  <img
                    v-if="linkedinOrganization.logoUrl"
                    :src="linkedinOrganization.logoUrl"
                    alt=""
                    class="account-avatar"
                  >
                  <span class="account-name">{{ linkedinOrganization.localizedName }}</span>
                  <i class="el-icon-top-right account-external-icon" aria-hidden="true" />
                </a>
                <p v-if="disconnectErrors.linkedin" class="card-error">{{ disconnectErrors.linkedin }}</p>
              </div>
              <div class="item-badge"><div class="status-pill"><i class="el-icon-success"></i> {{ $t('socialNetworks.badgeConnected') }}</div></div>
              <div class="item-action">
                <button
                  type="button"
                  class="uniform-btn btn-secondary"
                  @click="confirmDisconnect('LinkedIn', deconnexionLinkedin)"
                >
                  {{ $t('socialNetworks.disconnect') }}
                </button>
              </div>
            </div>

            <!-- Google (Succès) -->
            <div v-if="gmbSuccess" class="integration-item is-success">
              <div class="item-icon"><img alt="Google Business" :src="require(`@/assets/1200px-Google-My-Business_logo.svg.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>Google Business Profile</h4>
                <p v-if="gmbManagedByNetwork" class="card-message">{{ $t('socialNetworks.gmbManagedByNetwork') }}</p>
                <a
                  v-if="googleLocation && googleLocation.title && googleLocation.websiteUri"
                  :href="googleLocation.websiteUri"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="account-link"
                >
                  <span class="account-name">{{ googleLocation.title }}</span>
                  <i class="el-icon-top-right account-external-icon" aria-hidden="true" />
                </a>
                <span
                  v-else-if="googleLocation && googleLocation.title"
                  class="account-link account-link--static"
                >
                  <span class="account-name">{{ googleLocation.title }}</span>
                </span>
                <p v-if="disconnectErrors.google" class="card-error">{{ disconnectErrors.google }}</p>
              </div>
              <div class="item-badge"><div class="status-pill"><i class="el-icon-success"></i> {{ $t('socialNetworks.badgeConnected') }}</div></div>
              <div class="item-action">
                <button type="button" class="uniform-btn btn-secondary" :disabled="gmbManagedByNetwork" @click="confirmDisconnect('Google My Business', disconnectGoogle)">
                  {{ $t('socialNetworks.disconnect') }}
                </button>
              </div>
            </div>

          </div>
        </div>

        <!-- ============================================== -->
        <!-- SECTION 3 : UPSELL (BOOSTEZ VOTRE VISIBILITÉ)  -->
        <!-- ============================================== -->
        <div v-if="hasLocked" id="section-locked" class="status-section">
          <div class="section-header">
            <i class="el-icon-present"></i> Boostez votre visibilité
          </div>
          <div class="integration-list">

            <!-- Facebook (Locked / Upsell) -->
            <div v-if="fbLocked" class="integration-item is-locked">
              <div class="item-icon"><img alt="Facebook" :src="require(`@/assets/facebook-logo-5-1.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>Facebook Pages</h4>
                <p class="card-message">{{ $t('socialNetworks.lockedMessage') }}</p>
              </div>
              <div class="item-action">
                <button type="button" class="uniform-btn btn-contact" :disabled="sendingContactMail" @click="requestActivation('demande_demo_facebook')">
                  {{ $t('socialNetworks.contactUs') }}
                </button>
              </div>
            </div>

            <!-- Instagram (Locked / Upsell) -->
            <div v-if="igLocked" class="integration-item is-locked">
              <div class="item-icon"><img alt="Instagram" :src="require(`@/assets/2048px-Instagram_icon.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>Instagram Business</h4>
                <p class="card-message">{{ $t('socialNetworks.lockedMessage') }}</p>
              </div>
              <div class="item-action">
                <button type="button" class="uniform-btn btn-contact" :disabled="sendingContactMail" @click="requestActivation('demande_demo_instagram')">
                  {{ $t('socialNetworks.contactUs') }}
                </button>
              </div>
            </div>

            <!-- LinkedIn (Locked / Upsell) -->
            <div v-if="inLocked" class="integration-item is-locked">
              <div class="item-icon"><img alt="LinkedIn" :src="require(`@/assets/linkedin-logo.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>LinkedIn</h4>
                <p class="card-message">{{ $t('socialNetworks.lockedMessage') }}</p>
              </div>
              <div class="item-action">
                <button type="button" class="uniform-btn btn-contact" :disabled="sendingContactMail" @click="requestActivation('demande_demo_linkedin')">
                  {{ $t('socialNetworks.contactUs') }}
                </button>
              </div>
            </div>

            <!-- Google (Locked / Upsell) -->
            <div v-if="gmbLocked" class="integration-item is-locked">
              <div class="item-icon"><img alt="Google Business" :src="require(`@/assets/1200px-Google-My-Business_logo.svg.png`)" class="brand-logo" /></div>
              <div class="item-text">
                <h4>Google Business Profile</h4>
                <p class="card-message">{{ $t('socialNetworks.lockedMessage') }}</p>
              </div>
              <div class="item-action">
                <button type="button" class="uniform-btn btn-contact" :disabled="sendingContactMail" @click="requestActivation('demande_demo_gmb')">
                  {{ $t('socialNetworks.contactUs') }}
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </ubi-panel>
  </ubi-page-container>
</template>

<script>
import {
  disconnectFacebook,
  disconnectLinkedin,
  issetTokenUtilisateur, recordDiffusionsLinkedin,
  recordDiffusionsMeta
} from '@/services/tokenUtilisateurApi'
import facebookLogin from '@/components/FacebookLogin'
import googleLogin from '@/components/GoogleLogin.vue'
import { getDiffusionAnnonceurByCodeName } from '@/services/portals'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'
import { sendEmail } from '@/services/email'
import { isActiveDataFlag } from '@/stores/app'

export default {
  name: 'social-networks-refonte',
  components: {
    UbiPanel,
    UbiPageContainer,
    FacebookLogin: facebookLogin,
    GoogleLogin: googleLogin
  },
  data () {
    return {
      loadingStatus: false,
      connexionFacebook: false,
      connexionGoogle: false,
      facebookData: { pages: {} },
      pagesFacebook: [],
      pagesInstagram: [],
      facebookIds: [],
      instagramIds: {},
      facebookUserId: null,
      dialogFacebookPages: false,
      choixFacebookPage: null,
      linkedinOrganizations: [],
      dialogLinkedinOrganizations: false,
      choixLinkedinOrganization: null,
      linkedinOrganization: {},
      googleLocation: null,
      disconnectErrors: {
        facebook: null,
        google: null,
        linkedin: null
      },
      sendingContactMail: false
    }
  },
  computed: {
    user () { return this.$store.state.app.user },
    sitimmoUser () { return this.$store.state.app.sitimmoUser },

    // Possessions
    possedeFacebook () { return this.user.haveFacebook || this.user.haveFacebookBV },
    possedeInstagram () { return this.user.possedeInstagram || this.user.haveInstagramBV },
    possedeLinkedin () { return this.user.haveLinkedIn || this.user.haveLinkedInBV },
    possedeGmb () { return this.user.haveGMB || this.user.haveGMBBV },
    gmbManagedByNetwork () {
      const activeData = this.sitimmoUser && this.sitimmoUser.activeData
      if (!Array.isArray(activeData)) {
        return false
      }
      const entry = activeData.find(function (item) {
        return item && item.code === 'SHARED_TOKEN_GMB'
      })
      return isActiveDataFlag(entry)
    },
    connexionLinkedin () { return this.sitimmoUser.linkedinUrlConnexion },

    // ==========================================
    // ROUTAGE DES CARTES (COMPUTEDS)
    // ==========================================
    facebookAccount () {
      return (this.pagesFacebook && this.pagesFacebook.length > 0) ? this.pagesFacebook[0] : null
    },
    instagramAccount () {
      return (this.pagesInstagram && this.pagesInstagram.length > 0) ? this.pagesInstagram[0] : null
    },
    instagramAccountLabel () {
      if (!this.instagramAccount) {
        return ''
      }
      if (this.instagramAccount.name) {
        return this.instagramAccount.name
      }
      if (this.instagramAccount.username) {
        return '@' + this.instagramAccount.username
      }
      return ''
    },

    fbWarning () { return this.possedeFacebook && !this.connexionFacebook },
    fbSuccess () { return this.possedeFacebook && this.connexionFacebook },
    fbLocked () { return !this.possedeFacebook },

    igWarning () { return this.possedeInstagram && !this.connexionFacebook },
    igSuccess () { return this.possedeInstagram && this.connexionFacebook },
    igLocked () { return !this.possedeInstagram },

    inWarning () { return this.possedeLinkedin && this.connexionLinkedin },
    inSuccess () { return this.possedeLinkedin && !this.connexionLinkedin },
    inLocked () { return !this.possedeLinkedin },

    gmbWarning () { return this.possedeGmb && !this.connexionGoogle },
    gmbSuccess () { return this.possedeGmb && this.connexionGoogle },
    gmbLocked () { return !this.possedeGmb },

    hasWarnings () { return this.fbWarning || this.igWarning || this.inWarning || this.gmbWarning },
    hasSuccess () { return this.fbSuccess || this.igSuccess || this.inSuccess || this.gmbSuccess },
    hasLocked () { return this.fbLocked || this.igLocked || this.inLocked || this.gmbLocked },

    warningsCount () {
      return [this.fbWarning, this.igWarning, this.inWarning, this.gmbWarning]
        .filter(Boolean).length
    },
    successCount () {
      return [this.fbSuccess, this.igSuccess, this.inSuccess, this.gmbSuccess]
        .filter(Boolean).length
    }
  },
  beforeMount () {
    this.handleFacebook()
    this.handleLinkedin()
  },
  methods: {
    reconnectFacebook () {
      if (this.$refs.facebookLogin && typeof this.$refs.facebookLogin.login === 'function') {
        this.$refs.facebookLogin.login()
      }
    },
    onGoogleConnectionChange (isConnected) {
      this.connexionGoogle = !!isConnected
      if (!isConnected) {
        this.googleLocation = null
      }
    },
    onGoogleLocationChange (location) {
      this.googleLocation = location || null
    },
    reconnectGoogle () {
      if (this.gmbManagedByNetwork) {
        return
      }
      if (this.$refs.googleLogin && typeof this.$refs.googleLogin.login === 'function') {
        this.$refs.googleLogin.login()
      }
    },
    disconnectGoogle () {
      if (this.gmbManagedByNetwork) {
        return
      }
      this.disconnectErrors.google = null
      try {
        if (this.$refs.googleLogin && typeof this.$refs.googleLogin.logout === 'function') {
          this.$refs.googleLogin.logout()
        }
      } catch (error) {
        this.disconnectErrors.google = this.$t('socialNetworks.disconnectError')
      }
    },
    confirmDisconnect (network, disconnectFn) {
      this.$confirm(
        this.$t('socialNetworks.disconnectConfirm', { network }),
        this.$t('socialNetworks.disconnectConfirmTitle'),
        {
          confirmButtonText: this.$t('socialNetworks.disconnectConfirmButton'),
          cancelButtonText: this.$t('socialNetworks.disconnectCancelButton'),
          type: 'warning',
          confirmButtonClass: 'el-button--danger'
        }
      ).then(() => {
        if (typeof disconnectFn === 'function') {
          return disconnectFn.call(this)
        }
      }).catch(() => {})
    },
    /**
     * Même source que main (/facebook/infos), avec matching robuste :
     * - compare les ids en string
     * - si 1 seule page Meta → on l'utilise (cas Badabing / id diffusion divergente)
     * - sinon GET /facebook/page/{id} pour le nom Graph
     * - dernier recours : id diffusion (avatar Graph + lien FB)
     * IG = instagram_business_account (profile_picture_url, username, name)
     */
    async handleFacebook () {
      this.loadingStatus = true
      this.connexionFacebook = false
      this.pagesFacebook.splice(0)
      this.pagesInstagram.splice(0)
      this.facebookIds.splice(0)
      this.instagramIds = {}

      if (this.possedeFacebook || this.possedeInstagram) {
        const issetToken = await issetTokenUtilisateur()
        if (issetToken && (issetToken.isset_token === true)) {
          const facebookPageId = await this.getFacebookPageId()
          const facebookInfos = await this.getInfosFacebook()
          const facebookPages = (facebookInfos && facebookInfos.pages) ? facebookInfos.pages : []

          if (!facebookPageId || (facebookPageId == 'default_value')) {
            this.pagesFacebook = this.pagesFacebook.concat(facebookPages)
            if (facebookPages.length > 0) {
              for (let i = 0; i < facebookPages.length; i++) {
                const dataPage = facebookPages[i]
                this.facebookIds.push(dataPage.id)
                if (dataPage.instagram_business_account && dataPage.instagram_business_account.id) {
                  this.instagramIds[dataPage.id] = dataPage.instagram_business_account.id
                  this.pagesInstagram.push(dataPage.instagram_business_account)
                }
              }
              this.dialogFacebookPages = true
            }
          } else {
            this.connexionFacebook = true
            const resolvedPage = await this.resolveConnectedFacebookPage(facebookPageId, facebookPages)
            this.pagesFacebook.push(resolvedPage)
            this.facebookIds.push(resolvedPage.id)
            if (resolvedPage.instagram_business_account && resolvedPage.instagram_business_account.id) {
              this.instagramIds[resolvedPage.id] = resolvedPage.instagram_business_account.id
              this.pagesInstagram.push(resolvedPage.instagram_business_account)
            }

            // IG sur une autre page Meta si la page sélectionnée n'en a pas
            if (this.pagesInstagram.length === 0) {
              for (let i = 0; i < facebookPages.length; i++) {
                const dataPage = facebookPages[i]
                if (dataPage.instagram_business_account && dataPage.instagram_business_account.id) {
                  this.instagramIds[dataPage.id] = dataPage.instagram_business_account.id
                  this.pagesInstagram.push(dataPage.instagram_business_account)
                  break
                }
              }
            }
          }
          if (this.possedeInstagram) {
            await this.ensureInstagramAccount()
          }
        }
      }
      this.loadingStatus = false
    },
    async getInfosFacebook () {
      return HTTP_HYPER_ESPACE_BACKEND.get('/facebook/infos').then(response => {
        return response.data
      }).catch(error => {
        console.log('getInfosFacebook: ' + error)
        return { pages: [] }
      })
    },
    async getFacebookPageById (pageId) {
      if (!pageId) {
        return null
      }
      return HTTP_HYPER_ESPACE_BACKEND.get('/facebook/page/' + encodeURIComponent(pageId)).then(response => {
        return response.data
      }).catch(error => {
        console.log('getFacebookPageById: ' + error)
        return null
      })
    },
    async getInstagramAccountById (igUserId) {
      if (!igUserId) {
        return null
      }
      return HTTP_HYPER_ESPACE_BACKEND.get('/facebook/instagram/' + encodeURIComponent(igUserId)).then(response => {
        return response.data
      }).catch(error => {
        console.log('getInstagramAccountById: ' + error)
        return null
      })
    },
    async getInstagramUserId () {
      const instagramData = this.user.socialNetworkCodenames.find((element) => element[1].includes('INSTAGRAM'))
      if (!instagramData || !instagramData[1]) {
        return ''
      }
      const instagramDiffusion = await getDiffusionAnnonceurByCodeName(instagramData[1])
      if (instagramDiffusion && instagramDiffusion.infos && instagramDiffusion.infos._embedded &&
          instagramDiffusion.infos._embedded.diffusion_annonceur && instagramDiffusion.infos._embedded.diffusion_annonceur.length > 0) {
        return this.getIdentifiantValeur(
          instagramDiffusion.infos._embedded.diffusion_annonceur[0].identifiants,
          1
        )
      }
      return ''
    },
    async ensureInstagramAccount () {
      if (this.instagramAccount && this.instagramAccount.username) {
        return
      }
      const igUserId = await this.getInstagramUserId()
      if (!igUserId) {
        return
      }
      const profile = await this.getInstagramAccountById(igUserId)
      if (profile && (profile.username || profile.name)) {
        this.pagesInstagram.splice(0)
        this.pagesInstagram.push(profile)
        this.instagramIds[profile.id || igUserId] = profile.id || igUserId
      }
    },
    pageHasUsableName (page, facebookPageId) {
      return !!(page && page.name && String(page.name) !== String(page.id) && String(page.name) !== String(facebookPageId))
    },
    async resolveConnectedFacebookPage (facebookPageId, facebookPages) {
      let matchedPage = null
      for (let i = 0; i < facebookPages.length; i++) {
        if (String(facebookPages[i].id) === String(facebookPageId)) {
          matchedPage = facebookPages[i]
          break
        }
      }
      if (!matchedPage && facebookPages.length === 1) {
        matchedPage = facebookPages[0]
      }
      if (this.pageHasUsableName(matchedPage, facebookPageId)) {
        return matchedPage
      }
      const pageFromId = await this.getFacebookPageById(facebookPageId)
      if (this.pageHasUsableName(pageFromId, facebookPageId)) {
        return {
          id: pageFromId.id || facebookPageId,
          name: pageFromId.name,
          instagram_business_account: pageFromId.instagram_business_account
        }
      }
      if (matchedPage) {
        return {
          id: matchedPage.id,
          name: matchedPage.name || facebookPageId,
          instagram_business_account: matchedPage.instagram_business_account
        }
      }
      return {
        id: facebookPageId,
        name: facebookPageId
      }
    },
    async savePageFacebook () {
      if (this.choixFacebookPage) {
        this.loadingStatus = true
        this.dialogFacebookPages = false
        let instaId = null
        if (this.instagramIds[this.choixFacebookPage]) {
          instaId = this.instagramIds[this.choixFacebookPage]
        }
        await recordDiffusionsMeta(this.facebookUserId, instaId, this.choixFacebookPage)
        await this.handleFacebook()
        this.loadingStatus = false
      }
    },
    async deconnexionFacebook () {
      this.disconnectErrors.facebook = null
      this.loadingStatus = true
      try {
        await disconnectFacebook()
        await this.handleFacebook()
      } catch (error) {
        this.disconnectErrors.facebook = this.$t('socialNetworks.disconnectError')
      }
      this.loadingStatus = false
    },
    async deconnexionLinkedin () {
      this.disconnectErrors.linkedin = null
      this.loadingStatus = true
      try {
        await disconnectLinkedin()
        this.linkedinOrganization = {}
        await this.handleLinkedin()
      } catch (error) {
        this.disconnectErrors.linkedin = this.$t('socialNetworks.disconnectError')
      }
      this.loadingStatus = false
    },
    /**
     * Lit identifiants[n].valeur en gérant objet keyed par numero OU tableau [{numero, valeur}].
     */
    getIdentifiantValeur (identifiants, numero) {
      if (!identifiants) return ''
      const direct = identifiants[numero]
      if (direct && direct.valeur != null && direct.valeur !== '') {
        return String(direct.valeur).trim()
      }
      if (Array.isArray(identifiants)) {
        const found = identifiants.find(item => item && Number(item.numero) === Number(numero))
        if (found && found.valeur != null && found.valeur !== '') {
          return String(found.valeur).trim()
        }
      }
      return ''
    },
    async getFacebookPageId () {
      let facebookPageId = ''
      const facebookData = this.user.socialNetworkCodenames.find((element) => element[1].includes('FACEBOOK'))
      if (facebookData && facebookData[1]) {
        const facebookDiffusion = await getDiffusionAnnonceurByCodeName(facebookData[1])
        if (facebookDiffusion && facebookDiffusion.infos && facebookDiffusion.infos._embedded &&
            facebookDiffusion.infos._embedded.diffusion_annonceur && facebookDiffusion.infos._embedded.diffusion_annonceur.length > 0) {
          facebookPageId = this.getIdentifiantValeur(
            facebookDiffusion.infos._embedded.diffusion_annonceur[0].identifiants,
            1
          )
        }
      } else {
        const instagramData = this.user.socialNetworkCodenames.find((element) => element[1].includes('INSTAGRAM'))
        if (instagramData && instagramData[1]) {
          const instagramDiffusion = await getDiffusionAnnonceurByCodeName(instagramData[1])
          if (instagramDiffusion && instagramDiffusion.infos && instagramDiffusion.infos._embedded &&
              instagramDiffusion.infos._embedded.diffusion_annonceur && instagramDiffusion.infos._embedded.diffusion_annonceur.length > 0) {
            facebookPageId = this.getIdentifiantValeur(
              instagramDiffusion.infos._embedded.diffusion_annonceur[0].identifiants,
              3
            )
          }
        }
      }
      return facebookPageId
    },
    async handleLinkedin () {
      if (this.possedeLinkedin) {
        const urlConnexion = await this.getLinkedinUrlConnexion()
        this.sitimmoUser.linkedinUrlConnexion = urlConnexion
        if (!urlConnexion) {
          const linkedinData = this.user.socialNetworkCodenames.find((element) => element[1].includes('LINKEDIN'))
          if (linkedinData && linkedinData[1]) {
            const diffusion = await getDiffusionAnnonceurByCodeName(linkedinData[1])
            if (diffusion && diffusion.infos && diffusion.infos._embedded && diffusion.infos._embedded.diffusion_annonceur && diffusion.infos._embedded.diffusion_annonceur.length > 0) {
              const identifiants = diffusion.infos._embedded.diffusion_annonceur[0].identifiants
              if (identifiants[1] && identifiants[1].valeur && parseFloat(identifiants[1].valeur)) {
                this.linkedinOrganization = await this.getLinkedinOrganization(parseFloat(identifiants[1].valeur))
              } else {
                this.linkedinOrganizations = await this.getLinkedinOrganizations()
                if (this.linkedinOrganizations) this.dialogLinkedinOrganizations = true
              }
            }
          }
        }
      }
    },
    async getLinkedinOrganizations () {
      return HTTP_HYPER_ESPACE_BACKEND.get('/linkedin/organizations').then(res => res.data).catch(err => console.log(err))
    },
    async saveOrganizationLinkedin () {
      if (this.choixLinkedinOrganization) {
        this.loadingStatus = true
        this.dialogLinkedinOrganizations = false
        await recordDiffusionsLinkedin(this.choixLinkedinOrganization)
        await this.handleLinkedin()
        this.loadingStatus = false
      }
    },
    async getLinkedinOrganization (organizationId) {
      return HTTP_HYPER_ESPACE_BACKEND.get('/linkedin/organization/' + organizationId).then(res => res.data).catch(err => console.log(err))
    },
    async getLinkedinUrlConnexion () {
      return HTTP_HYPER_ESPACE_BACKEND.get('/linkedin/urlconnexion').then(res => res.data.linkedinUrlConnexion).catch(err => console.log(err))
    },
    async requestActivation (analyticsCategory) {
      if (this.sendingContactMail) {
        return
      }
      if (this.$ga) {
        this.$ga.event('navigation_permanente', 'clic', analyticsCategory, this.sitimmoUser.id)
      }
      this.sendingContactMail = true
      try {
        const user = this.user || {}
        const sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
        const login = (this.sitimmoUser && this.sitimmoUser.login) || user.username || user.login || ''
        const lastname = user.lastname || ''
        const firstname = user.firstname || ''
        const email = user.email || ''
        const phone = user.phone || ''

        const mailData = {
          to: sendTo,
          replyTo: email,
          subject: '[CONTACT-ESPACE-CLIENT] [' + login + '] Demande de rappel sur l\'activation d\'une diffusion Social Manager',
          email_content: 'Bonjour, je souhaite être recontacté pour l\'activation d\'une diffusion de réseau social.\n\n' +
            'Contact :\n' +
            lastname + ' ' + firstname + '\n' +
            email + '\n' +
            phone,
          contact_name: [lastname, firstname].filter(Boolean).join(' '),
          contact_email: email,
          contact_phone: phone
        }

        const response = await sendEmail(mailData)

        if (response.type === 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
        } else {
          this.$message({ message: this.$t('socialNetworks.emailSend'), type: 'success' })
        }
      } catch (e) {
        console.error('Erreur envoi email activation Social Manager', e)
        this.$message({ message: this.$t('error.found'), type: 'error' })
      } finally {
        this.sendingContactMail = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/theme/_bootstrap.scss";

/* =========================================================
   STYLE "PIXEL PERFECT" - Grille Stricte & Couleurs
   Typo alignée sur le thème EC : Open Sans (corps) / Dosis (titres, UI)
   ========================================================= */

.social-panel {
  padding: 40px;
  background-color: #ffffff;
  font-family: $font-family-sans-serif;
}
.header-section { margin-bottom: 40px; }
.header-subtitle { color: #64748b; font-size: 14px; margin: 0; }

/* SECTIONS DYNAMIQUES */
.status-section { margin-bottom: 40px; }
.section-header {
  font-family: $font-family-sans-serif-alt;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
#section-warning { background-color: #fffbf0; border: 1px solid #fde68a; border-radius: 12px; padding: 24px; }
#section-warning .section-header { color: #d97706; }
#section-warning .integration-item { border-color: #fcd34d; }

#section-success .section-header { color: #00CC73; }
#section-locked .section-header { color: #94a3b8; }

.integration-list { display: flex; flex-direction: column; gap: 16px; }

/* =========================================================
   LA GRILLE STRICTE (CORRECTION RESPONSIVE)
   ========================================================= */
.integration-item {
  position: relative;
  display: grid;
  /* Définition des 4 zones : Icône | Texte | Badge | Action */
  grid-template-areas: "icon text badge action";
  grid-template-columns: 56px 1fr 150px 160px;
  gap: 24px;
  align-items: center;
  padding: 16px 24px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  min-height: 96px;
  transition: box-shadow 150ms ease;
}
.integration-item:hover { box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); }

/* BORDURES & COULEURS EXACTES */
.integration-item::before {
  content: ''; position: absolute; top: -1px; bottom: -1px; left: -1px; width: 4px;
  border-top-left-radius: 8px; border-bottom-left-radius: 8px;
}
.integration-item.is-success::before { background-color: #00CC73; }
.integration-item.is-success .status-pill { background-color: #ecfdf5; color: #00CC73; }

.integration-item.is-warning::before { background-color: #f59e0b; }

.integration-item.is-locked,
.integration-item.is-warning {
  grid-template-areas: "icon text action";
  grid-template-columns: 56px 1fr 160px;
}
.integration-item.is-locked { opacity: 0.9; }
.integration-item.is-locked::before { display: none; }
.integration-item.is-locked .item-icon { filter: grayscale(100%); opacity: 0.5; }

/* AFFECTATION DES ZONES DE LA GRILLE */
.item-icon { grid-area: icon; width: 56px; height: 56px; display: flex; align-items: center; justify-content: center; }
.brand-logo { width: 48px; height: 48px; object-fit: contain; }

.item-text { grid-area: text; display: flex; flex-direction: column; gap: 4px; overflow: hidden; }
.item-text h4 {
  font-family: $font-family-sans-serif-alt;
  font-size: 15px;
  font-weight: 700;
  color: #03323a;
  margin: 0;
}
.item-text p { font-size: 13.5px; color: #64748b; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.item-text .card-message {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.4;
}
.item-text .card-error {
  color: #dc2626;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

.alert-inline {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 4px;
  padding: 8px 10px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 6px;
}
.alert-inline > i { color: #E87722; font-size: 16px; margin-top: 1px; flex-shrink: 0; }
.alert-inline .card-message { color: #9a3412; }

/* Ligne compte : avatar + nom + icône lien externe */
.account-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  font-size: 13.5px;
  font-weight: 600;
  color: #475569;
  text-decoration: none;
  cursor: pointer;
}
.account-link:hover { text-decoration: underline; color: #0C505B; }
.account-link--static {
  cursor: default;
  pointer-events: none;
}
.account-link--static:hover { text-decoration: none; color: #475569; }
.account-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.account-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.account-external-icon { font-size: 12px; flex-shrink: 0; color: #64748b; }

.item-badge { grid-area: badge; display: flex; justify-content: flex-end; }
.status-pill {
  font-family: $font-family-sans-serif-alt;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 50px;
  min-width: 130px;
  box-sizing: border-box;
}

.item-action { grid-area: action; position: relative; display: flex; justify-content: flex-end; }
.facebook-login-host,
.google-login-host {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  pointer-events: none;
}

/* BOUTONS FIGÉS */
.uniform-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 38px;
  border-radius: 6px;
  font-family: $font-family-sans-serif-alt;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
  transition: all 150ms ease;
  box-sizing: border-box;
}
.btn-primary { background-color: #03323a; color: #ffffff; border: 1px solid #03323a; }
.btn-primary:hover { background-color: #0c505b; }
.btn-reconnect { background-color: #E87722; color: #ffffff; border: 1px solid #E87722; }
.btn-reconnect:hover { background-color: #d56a1a; border-color: #d56a1a; }
.btn-contact { background-color: #0C505B; color: #ffffff; border: 1px solid #0C505B; }
.btn-contact:hover { background-color: #03323a; border-color: #03323a; }
.uniform-btn:disabled,
.uniform-btn:disabled:hover {
  opacity: 0.6;
  cursor: not-allowed;
}
.btn-reconnect:disabled,
.btn-reconnect:disabled:hover {
  background-color: #E87722;
  border-color: #E87722;
  color: #ffffff;
}
.btn-secondary:disabled,
.btn-secondary:disabled:hover {
  background-color: #f1f5f9;
  color: #475569;
  border-color: #e2e8f0;
}
.btn-contact:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-secondary { background-color: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; }
.btn-secondary:hover { background-color: #e2e8f0; border-color: #cbd5e1; color: #334155; }
.btn-outline { background-color: #ffffff; color: #03323a; border: 1px solid #cbd5e1; }
.btn-outline:hover { background-color: #f8fafc; border-color: #03323a; }


/* =========================================================
   MEDIA QUERIES (CORRECTION DU RESPONSIVE)
   ========================================================= */

/* Tablette et petits écrans (< 992px) */
@media (max-width: 992px) {
  .integration-item {
    grid-template-columns: 56px 1fr; /* 2 colonnes seulement */
    /* Empilement propre : le badge et le bouton s'alignent sous le texte */
    grid-template-areas:
      "icon text"
      ". badge"
      ". action";
    gap: 12px 20px;
  }

  .item-badge { justify-content: flex-start; } /* Aligné à gauche sous le texte */
  .item-action { justify-content: flex-start; align-items: flex-start; }

  .integration-item.is-locked,
  .integration-item.is-warning {
    grid-template-areas:
      "icon text"
      ". action";
    grid-template-columns: 56px 1fr;
  }

  /* On limite la taille du bouton pour qu'il ne soit pas monstrueux sur une tablette */
  .item-action .uniform-btn {
    width: 100%;
    max-width: 260px;
  }

  #section-warning { padding: 16px; }
}

/* Mobile étroit (< 576px) */
@media (max-width: 576px) {
  .integration-item {
    grid-template-areas:
      "icon text"
      "badge badge" /* Le badge prend toute la largeur */
      "action action"; /* Le bouton prend toute la largeur */
    gap: 16px;
  }

  .item-icon { align-self: flex-start; margin-top: 4px; }
  .item-text p { white-space: normal; overflow: visible; text-overflow: clip; } /* Le texte revient à la ligne si besoin */

  .integration-item.is-locked,
  .integration-item.is-warning {
    grid-template-areas:
      "icon text"
      "action action";
  }

  /* Le bouton prend 100% de l'écran pour un clic facile au doigt */
  .item-action .uniform-btn {
    max-width: 100%;
  }
}
</style>
